<ng-content
  *ngIf="(variant !== 'typing' && variant !== 'circle-spin') || !loading"
></ng-content>
<ng-container *ngIf="variant === 'circle-spin' && loading">
  <div class="circle-spin">
    <div class="top">
      <div class="fill-y"></div>
    </div>
    <div class="bottom">
      <div class="fill-b"></div>
    </div>
  </div>
</ng-container>
<ng-container *ngIf="variant === 'typing'">
  <span class="dot"></span>
  <span class="dot"></span>
  <span class="dot"></span>
</ng-container>
